import { PERSON_TYPE_ENUM } from 'enums/PersonTypeEnum'
import { FINANCING_ORIGIN_ENUM } from 'enums/FinancingOrigin'
import { type DefaultValuesForm } from '../components/FormManager/types'

export const INICIAL_VALUES_FORM: DefaultValuesForm = {
  origin: FINANCING_ORIGIN_ENUM.VALUE,
  client_type: PERSON_TYPE_ENUM.NATURAL,
  grace_days: '90',
  total_value: 0.0,
  labor_value: 0.0,
  equipments_value: 0.0,
  client_income: 0.0,
  shareholder_document: '',
  client_birth_date: '',
  client_document: '',
  client_name: '',
  client_phone: '',
  client_cep: '',
}
